import { render, staticRenderFns } from "./RevenueReport.vue?vue&type=template&id=4b485deb&scoped=true"
import script from "./RevenueReport.vue?vue&type=script&lang=js"
export * from "./RevenueReport.vue?vue&type=script&lang=js"
import style0 from "./RevenueReport.vue?vue&type=style&index=0&id=4b485deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b485deb",
  null
  
)

export default component.exports